import { render, staticRenderFns } from "./modalRegistro.vue?vue&type=template&id=5b201be0&scoped=true"
import script from "./modalRegistro.vue?vue&type=script&lang=js"
export * from "./modalRegistro.vue?vue&type=script&lang=js"
import style0 from "./modalRegistro.vue?vue&type=style&index=0&id=5b201be0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b201be0",
  null
  
)

export default component.exports